import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { Form, Input, Modal, Spin, Select } from "antd";
import co from "co";
import styles from "./AddEditProjectDialog.module.less";

const FormItem = Form.Item;
const Option = Select.Option;

var ModuleMap = {};
ModuleMap["AccountCreation"] = "Account Creation";
ModuleMap["SocialNetwork"] = "Web 2.0 Blogs";
ModuleMap["Bookmarking"] = "Bookmarking";
ModuleMap["Wiki"] = "Wiki";
ModuleMap["WebProfile"] = "Web 2.0 Profile";
ModuleMap["ArticleDirectory"] = "Article Directory";
ModuleMap["ForumProfile"] = "Forum Profile";
ModuleMap["PressRelease"] = "Press Release";
ModuleMap["GooglePlace"] = "Google Place";
ModuleMap["PDF"] = "PDF";
ModuleMap["Private"] = "Private Blog";
ModuleMap["PrivateBookmark"] = "Private Bookmark";
ModuleMap["Indexer"] = "Indexer";

@Form.create({
	mapPropsToFields(props) {
		return props.fields;
	}
})
class AddEditProjectForm extends Component {
	validateForm = callback => {
		this.props.form.validateFieldsAndScroll(callback);
	};

	getValues = () => {
		return {
			module: this.props.form.getFieldValue("module"),
			name: this.props.form.getFieldValue("name")
		};
	};

	render() {
		const form = this.props.form;
		return (
			<Fragment>
				<FormItem
					labelCol={{ span: 5 }}
					wrapperCol={{ span: 15 }}
					label="Module"
				>
					{form.getFieldDecorator("module", {
						rules: [
							{
								required: true,
								message: "Please select project type"
							}
						]
					})(
						<Select
							style={{ width: 200 }}
							dropdownClassName={styles.moduleDropDown}
							placeholder="Select a project type"
							disabled={this.props.edit}
						>
							{Object.keys(ModuleMap).map(key => {
								return (
									<Option key={key} value={key}>
										{ModuleMap[key]}
									</Option>
								);
							})}
						</Select>
					)}
				</FormItem>
				<FormItem labelCol={{ span: 5 }} wrapperCol={{ span: 15 }} label="Name">
					{form.getFieldDecorator("name", {
						rules: [
							{
								required: true,
								message: "Please enter project name"
							}
						]
					})(<Input placeholder="My great SEO project" />)}
				</FormItem>
			</Fragment>
		);
	}
}

@inject("rootStore")
@observer
class AddEditProjectDialog extends Component {
	mapPropsToFields = () => {
		const {
			rootStore: { campaignStore }
		} = this.props;

		const ui = campaignStore.ui;

		if (ui.currentProject == null) {
			return {};
		} else {
			return {
				module: Form.createFormField({
					value: ui.currentProject.module
				}),
				name: Form.createFormField({
					value: ui.currentProject.name
				})
			};
		}
	};

	hideDialog = () => {
		const {
			rootStore: { campaignStore }
		} = this.props;

		const ui = campaignStore.ui;

		if (ui.addEditProjectDialogVisible) {
			campaignStore.hideAddEditProjectDialog();
			return;
		}
		if (ui.duplicateProjectDialogVisible) {
			campaignStore.hideDuplicateProjectDialog();
		}
	};

	validateForm = () => {
		return new Promise(resolve => {
			this.internalForm.validateForm((err, vals) => {
				resolve(err);
			});
		});
	};

	addProject = () => {
		const {
			rootStore: { campaignStore }
		} = this.props;

		co(
			function*() {
				const response = yield this.validateForm();
				if (response != null) {
					return;
				}
				campaignStore.remoteAddProject(this.internalForm.getValues());
			}.bind(this)
		);
	};
	
	renameProject = () => {
		const {
			rootStore: { campaignStore }
		} = this.props;

		co(
			function*() {
				const response = yield this.validateForm();
				if (response != null) {
					return;
				}

				const values = this.internalForm.getValues();
				campaignStore.remoteRenameProject(values.name);
			}.bind(this)
		);
	};

	duplicateProject = () => {
		const {
			rootStore: { campaignStore }
		} = this.props;

		const ui = campaignStore.ui;
		
		// console.log("Last Project Action is " + ui.lastProjectAction);
		co(
			function*() {
				const response = yield this.validateForm();
				if (response != null) {
					return;
				}

				const values = this.internalForm.getValues();
				campaignStore.remoteDuplicateProject(values.name);
			}.bind(this)
		);
	};

	render() {
		const {
			rootStore: { campaignStore }
		} = this.props;
		const ui = campaignStore.ui;
		const spinning = ui.addingProject == true;

		let title = "Add New Project";

		let edit = false;

		if (ui.currentProject != null && ui.currentProject.id) {
			if (ui.lastProjectAction == "duplicate") {
				title = "Duplicate Project";
			} else if (ui.lastProjectAction == "rename") {
				title = "Rename Project";
			}
			edit = true;
		}

		let visible =
			ui.addEditProjectDialogVisible == true ||
			ui.duplicateProjectDialogVisible;
		return (
			<Modal
				visible={visible}
				title={title}
				okText="Save"
				onCancel={this.hideDialog}
				onOk={
					ui.lastProjectAction == "rename"
						? this.renameProject
						: ui.lastProjectAction == "add"
							? this.addProject
							: this.duplicateProject
				}
			>
				<Spin spinning={spinning}>
					<AddEditProjectForm
						fields={this.mapPropsToFields()}
						wrappedComponentRef={internalForm => {
							this.internalForm = internalForm;
						}}
						edit={edit}
					/>
				</Spin>
			</Modal>
		);
	}
}

export default AddEditProjectDialog;
